import React from "react";
import shelterIcon from "../../../../../assets/icons/shelter.svg";
import { connect } from "react-redux";
import {
    SubHeadTitle,
    ImageWrap,
    KeyStyle,
    ValueStyle,
    KeyStyleAddress
  } from "./Details/styles";
  import { MarginBottom } from "./AccordionContent/styles";
  import { filterDataWithValue } from "../../Data/FilterDropDownData";

export const MultipleCharitiesAccordion = props => {
    let name = props.successor.contactFirstName+" "+props.successor.contactLastName;
  return (
    <div>
      <SubHeadTitle paddingTop="0">
        <ImageWrap marginRight="10px" src={shelterIcon} alt="Charity" />
        Charity {props.index + 1}
      </SubHeadTitle>
      <MarginBottom marginBottom="20px">
      <ValueStyle marginLeft="29px" lineHeight="2">
            {props.successor.name} | {props.successor.charityAllocPercent}%
          </ValueStyle> 
        <div>
          <KeyStyle lineHeight="2" marginLeft="29px">
          EIN:&nbsp;
            <ValueStyle lineHeight="2">
              {props.successor.ein ? props.successor.ein : <>&mdash;</>}
            </ValueStyle>
          </KeyStyle>
        </div> 

        <div>
          <KeyStyle lineHeight="2" marginLeft="29px">
          Contact number:&nbsp;
            <ValueStyle lineHeight="2">
              {props.successor.contactPhone ? props.successor.contactPhone : <>&mdash;</>}
            </ValueStyle>
          </KeyStyle>
        </div>

        <div>
          <KeyStyle lineHeight="2" marginLeft="29px">
            Web Address:&nbsp;
            <ValueStyle lineHeight="2">
              {props.successor.webAddress ? props.successor.webAddress : <>&mdash;</>}
            </ValueStyle>
          </KeyStyle>  
        </div>

        <div>
          <KeyStyleAddress lineHeight="2" marginLeft="29px">
            Address:&nbsp;
            <ValueStyle lineHeight="2">
              {props.successor.address.line1},
            </ValueStyle>
            {props.successor.address.line2 ? (
              <div>
                <ValueStyle lineHeight="2" marginLeft="67px">
                  {props.successor.address.line2},
                </ValueStyle>
              </div>
            ) : null}
            {props.successor.address.line3 ? (
              <div>
                <ValueStyle lineHeight="2" marginLeft="67px">
                  {props.successor.address.line3},
                </ValueStyle>
              </div>
            ) : null}
            <div>
              <ValueStyle lineHeight="2" marginLeft="67px">
                {props.successor.address.city},&nbsp;
                {props.successor.address.state ? props.successor.address.state + ',' : ''}&nbsp;
                {props.successor.address.zip},
              </ValueStyle>
            </div>
            <div>
              <ValueStyle lineHeight="2" marginLeft="67px">
                {
                  filterDataWithValue(
                    props.successor.address.country,
                    props.countryDropdown
                  )[0].desc
                }
              </ValueStyle>
            </div>
          </KeyStyleAddress>
        </div>
 
        <div>
          <KeyStyle lineHeight="2" marginLeft="29px">
          Grant Purpose:&nbsp;
            <ValueStyle lineHeight="2">
              {props.successor.grantPurpose === "OTHER" ? props.successor.otherGrantPurposeText : "Area of most need"}
            </ValueStyle>
          </KeyStyle>  
        </div>
        <div>
          <KeyStyle lineHeight="2" marginLeft="29px">
          Grant Recognition:&nbsp;
            <ValueStyle lineHeight="2">
              {props.successor.grantRecognition}
            </ValueStyle>
          </KeyStyle>  
        </div>
      </MarginBottom>
    </div>
  );
};

const mapStateToProps = (state, ownProps) => ({
    percentage: state.getIn([
      "npaFormReducer",
      "legacyOptions",
      "legacyOptions",
      "legacyOptions",
      `${ownProps.contentKey - 1}`,
      "percentage"
    ]),
    countryDropdown: state.getIn([
      "npaFormReducer",
      "dropdownValues",
      "data",
      "countries"
    ]),
  });

export default connect(mapStateToProps)(MultipleCharitiesAccordion);
